import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {flashcardDefaultContent} from './flashcardSectionDefaultContent';
import l10n from "../../../lang/locallang";

const flashcardSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(flashcardDefaultContent);
    const { frontOfCard, backOfCard } = l10n.flashcardTexts;
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content ? param.content : ``;
    param.style = param.style ? param.style : '';
    param.layout = param['@layout'] ? param['@layout'] : '';

    param.section = 'flashcardSection';
    let items = '';
    let defaultImage = '../../images/editor/CG_128481927.jpeg';
    let defaultContent = {
        1:{
            id: param.id + '_' + 1,
            front: {
                type: 'text',
                content: frontOfCard,
                image: '',
                asset_id: componentsHelper.setAssetUniqueID(null, param.id + '_' + 1, param.id, 'image'),
            },
            back: {
                type: 'text',
                content: backOfCard,
                image: '',
                asset_id: componentsHelper.setAssetUniqueID(null, param.id + '_' + 1, param.id, 'image'),
            }
        },
        2:{
            id: param.id + '_' + 2,
            front: {
                type: 'text',
                content: frontOfCard,
                image: '',
                asset_id: componentsHelper.setAssetUniqueID(null, param.id + '_' + 2, param.id, 'image'),
            },
            back: {
                type: 'image',
                content: backOfCard,
                image: defaultImage,
                asset_id: componentsHelper.setAssetUniqueID(null, param.id + '_' + 2, param.id, 'image'),
            }
        }
    }
    let list = param.content && param.content.flashcards ? param.content.flashcards : defaultContent;
    const { text, image, enterText, addNewItem } = l10n.editor;
    let contentHTML = '';
    for (let i in list) {
        let item = list[i];
        contentHTML += `
        <div class="flashcard-item" id="flashcard-1-${item.id}">
        <div class="flashcard-inner">
            <div class="flashcard-item_front ${item.front.type === 'image' ? '__image' : ''}">
            ${!is_public ? `
                <div class="flashcard-controls">
                    <div class="flashcard-control field-box change-type">
                        <div class="fake-select">
                            <span class="fake-select__value">${item.front.type === 'text' ? text : image}</span>
                            <ul>
                                <li class="fake-select__option" data-value="text" ${item.front.type === 'text' ? 'data-selected' : ''}>${text}</li>
                                <li class="fake-select__option" data-value="image" ${item.front.type === 'image' ? 'data-selected' : ''}>${image}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="flashcard-control image-settings">
                        <button class="btn btn-flashcard-image"><i class="icon icon-img_upload"></i></button>
                        <button class="btn btn-flashcard-delete"><i class="icon icon-trash"></i></button>
                    </div>
                </div>
            ` : ''}
                <div class="flashcard-card-inner">
                    ${item.front.type === 'text' ? `<div class="p-like" ${!is_public ? `onpaste="contentEditableFix(event)" contenteditable="true" placeholder="${enterText}"` : ''}>${item.front.content}</div>` : ''}
                    ${item.front.type === 'image' ? `<img src="${item.front.image ? item.front.image : defaultImage}" data-asset-id="${item.front.asset_id}" alt="card_${item.id}">` : ''}
                </div>
                <i class="icon_flip flip-btn"></i>
            </div>
            <div class="flashcard-item_back ${item.back.type === 'image' ? '__image' : ''}">
            ${!is_public ? `
                <div class="flashcard-controls">
                    <div class="flashcard-control field-box change-type">
                        <div class="fake-select">
                            <span class="fake-select__value">${item.back.type === 'text' ? text : image}</span>
                            <ul>
                                <li class="fake-select__option" data-value="text" ${item.back.type === 'text' ? 'data-selected' : ''}>${text}</li>
                                <li class="fake-select__option" data-value="image" ${item.back.type === 'image' ? 'data-selected' : ''}>${image}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="flashcard-control image-settings">
                        <button class="btn btn-flashcard-image"><i class="icon icon-img_upload"></i></button>
                        <button class="btn btn-flashcard-delete"><i class="icon icon-trash"></i></button>
                    </div>
                </div>
            ` : ''}
                <div class="flashcard-card-inner">
                    ${item.back.type === 'text' ? `<div class="p-like" ${!is_public ? `onpaste="contentEditableFix(event)" contenteditable="true" placeholder="${enterText}"` : ''}>${item.back.content}</div>` : ''}
                    ${item.back.type === 'image' ? `<img src="${item.back.image ? item.back.image : defaultImage}" data-asset-id="${item.back.asset_id}" alt="card_${item.id}">` : ''}
                </div>
                <i class="icon_flip flip-btn"></i>
            </div>
        </div>
    </div>`;
    }
    param.component = `
            <div class="flashcard-row">
                ${contentHTML}
            </div>
            ${!is_public ? `
            <div class="add-e-element-btn-wr">
                <button class="btn add-e-element-btn add-new-flashcard"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
            </div>` : ''}`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {flashcardSection};
